// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"768":"d5e06107","810":"18b348ff"}[chunkId] + ".chunk.js";
};